const kr = {
  10000001: 'SuperEx 2주년 축하',
  10000002: '로그인하시면 푸짐한 보상을 받으실 수 있습니다',
  10000003: '참가자 수에 따라 최대 10,000USDT의 상금이 주어지며, 참가자 수가 많을수록 상금의 규모도 커집니다. ',
  10000004: 'SuperEx 두 주년 기념',
  10000005: '선물 거래 대회에서 20,000 USDT를 획득하다',
  10000006: `선물 거래량 순위 경쟁을 통해 최대 <span style="color: #ffc72b;">10,000</span> USDT의 보너스 풀을 잠금 해제하세요`,
  10000007: '퓨처스 챔피언십',
  10000008: '선물 거래 대회에서 20,000 USDT를 획득하다',
}
export default kr



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/kr.js